/* O'SKIN — interactions */
(function(){
  'use strict';

  // Header scroll
  var header = document.getElementById('OskinHeader');
  if (header) {
    window.addEventListener('scroll', function(){
      if (window.scrollY > 60) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }, { passive: true });
  }

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      q.parentElement.classList.toggle('open');
    });
  });

  // Countdown (data-deadline on .urgency, format YYYY-MM-DDTHH:mm:ss)
  var urgency = document.querySelector('.urgency');
  if (urgency) {
    var deadline = urgency.getAttribute('data-deadline');
    var target = deadline ? new Date(deadline).getTime() : (Date.now() + 1000*60*60*24*3);
    var d = urgency.querySelector('[data-cd="d"]');
    var h = urgency.querySelector('[data-cd="h"]');
    var m = urgency.querySelector('[data-cd="m"]');
    var s = urgency.querySelector('[data-cd="s"]');
    function pad(n){ return String(n).padStart(2,'0'); }
    function tick(){
      var now = Date.now();
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      var dd = Math.floor(diff / 86400);
      var hh = Math.floor((diff % 86400) / 3600);
      var mm = Math.floor((diff % 3600) / 60);
      var ss = diff % 60;
      if (d) d.textContent = pad(dd);
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
    }
    tick();
    setInterval(tick, 1000);
  }

  // Cart count refresh after async add (if any)
  var cartCount = document.getElementById('CartCount');
  function refreshCart(){
    if (!cartCount) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      cartCount.textContent = c.item_count;
    }).catch(function(){});
  }

  // Cart qty change updates (cart page)
  document.querySelectorAll('.qty-input').forEach(function(input){
    input.addEventListener('change', function(){
      var key = input.getAttribute('data-key');
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(){ window.location.reload(); });
    });
  });

  // Mobile menu (basic toggle)
  var menuToggle = document.getElementById('MobileMenuToggle');
  var nav = document.querySelector('.nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function(){
      nav.classList.toggle('mobile-open');
    });
  }
})();
